export function recruitFaq() {
  const applicationTab = document.querySelector('.p-recruit-faq__tab--application');
  const companyTab = document.querySelector('.p-recruit-faq__tab--company');
  const applicationContent = document.querySelector('[data-faq-content="application"]');
  const companyContent = document.querySelector('[data-faq-content="company"]');
  const allFaqItems = document.querySelectorAll('.p-recruit-faq__item');
  const moreBtn = document.querySelector('.p-recruit-faq__more-btn');
  
  if (!applicationTab || !companyTab || !applicationContent || !companyContent || !moreBtn) {
    return;
  }

  // 現在のアクティブタブ
  let currentTab = 'application';
  
  // 表示する初期のアイテム数
  const initialItemCount = 5;

  // 初期化
  function init() {
    setActiveTab('application');
    applicationTab.addEventListener('click', () => handleTabClick('application'));
    companyTab.addEventListener('click', () => handleTabClick('company'));
    setupFaqEvents();
    setupMoreButtonEvent();
    limitFaqDisplay('application');
  }

  // タブクリック処理
  function handleTabClick(tabType) {
    setActiveTab(tabType);
    updateTabContent(tabType);
    limitFaqDisplay(tabType);
  }

  // アクティブタブ設定
  function setActiveTab(tabType) {
    currentTab = tabType;
    updateTabAppearance(tabType);
  }

  // タブの見た目更新
  function updateTabAppearance(tabType) {
    applicationTab.classList.toggle('is-active', tabType === 'application');
    companyTab.classList.toggle('is-active', tabType === 'company');
  }

  // タブコンテンツの表示/非表示を更新
  function updateTabContent(tabType) {
    // コンテンツの表示/非表示
    applicationContent.style.display = tabType === 'application' ? 'block' : 'none';
    companyContent.style.display = tabType === 'company' ? 'block' : 'none';

    // FAQアイテムの初期状態をリセット
    const currentTabItems = tabType === 'application' 
      ? applicationContent.querySelectorAll('.p-recruit-faq__item')
      : companyContent.querySelectorAll('.p-recruit-faq__item');

    currentTabItems.forEach(item => {
      const answer = item.querySelector('.p-recruit-faq__answer');
      const button = item.querySelector('.p-recruit-faq__question');
      
      item.classList.remove('is-open');
      button.classList.remove('is-active');
      answer.classList.remove('is-active');
      answer.style.maxHeight = '0px';
    });
  }
  
  // FAQアコーディオンイベント設定
  function setupFaqEvents() {
    allFaqItems.forEach(item => {
      item.addEventListener('click', () => toggleFaq(item));
    });
  }

  // FAQアコーディオンの開閉切り替え
  function toggleFaq(item) {
    const isOpen = item.classList.contains('is-open');
    
    if (isOpen) {
      closeFaq(item);
    } else {
      openFaq(item);
    }
  }

  // FAQアコーディオンを開く
  function openFaq(item) {
    const answer = item.querySelector('.p-recruit-faq__answer');
    const button = item.querySelector('.p-recruit-faq__question');
    
    item.classList.add('is-open');
    button.classList.add('is-active');
    answer.classList.add('is-active');
    
    // 追加の余白を考慮してmax-heightを設定
    answer.style.maxHeight = (answer.scrollHeight + 64) + 'px'; // 64pxは追加の余白
    
    // ScrollTriggerを更新
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 300);
  }

  // FAQアコーディオンを閉じる
  function closeFaq(item) {
    const answer = item.querySelector('.p-recruit-faq__answer');
    const button = item.querySelector('.p-recruit-faq__question');
    
    item.classList.remove('is-open');
    button.classList.remove('is-active');
    answer.classList.remove('is-active');
    answer.style.maxHeight = '0px';
    
    // ScrollTriggerを更新
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 300);
  }

  // FAQアイテムの表示制限
  function limitFaqDisplay(tabType) {
    const currentTabItems = tabType === 'application' 
      ? applicationContent.querySelectorAll('.p-recruit-faq__item')
      : companyContent.querySelectorAll('.p-recruit-faq__item');
    
    currentTabItems.forEach((item, index) => {
      if (index >= initialItemCount) {
        item.style.display = 'none';
      } else {
        item.style.display = 'block';
      }
    });

    // 「すべて見る」ボタンの表示/非表示
    if (currentTabItems.length > initialItemCount) {
      moreBtn.style.display = 'inline-block';
      moreBtn.textContent = '+ すべて見る';
    } else {
      moreBtn.style.display = 'none';
    }
  }

  // 全てのFAQアイテムを表示
  function showAllFaqItems() {
    const currentTabItems = currentTab === 'application'
      ? applicationContent.querySelectorAll('.p-recruit-faq__item')
      : companyContent.querySelectorAll('.p-recruit-faq__item');

    currentTabItems.forEach(item => {
      item.style.display = 'block';
    });

    // 「すべて見る」ボタンを非表示
    moreBtn.style.display = 'none';

    // 高さ変更後にScrollTriggerとナビゲーション位置を更新
    setTimeout(() => {
      // ScrollTriggerの再計算
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }

      // カスタムイベントを発火してナビゲーションの再計算を促す
      window.dispatchEvent(new CustomEvent('heightChanged'));
    }, 100);
  }

  // 「すべて見る」ボタンのイベント設定
  function setupMoreButtonEvent() {
    moreBtn.addEventListener('click', showAllFaqItems);
  }

  // 初期化実行
  init();
} 